
export default {
  props: {
    label: { type: String, default: null },
    inputProps: { type: Object, default: () => {} },
  },
};
